import styled from "@emotion/styled";
import { PageLayout } from "../../shared/layouts/PageLayout";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import ChecklistIcon from "@mui/icons-material/Checklist";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import WebhookOutlinedIcon from "@mui/icons-material/WebhookOutlined";
import { DashboardCard } from "@shared/components/DashboardCard";
import { adminDashboardBreadcrumbs } from "@features/AdminDashboard/admin-dashboard-breadcrumbs";

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  width: 100%;
  position: relative;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export function AdminDashboard() {
  return (
    <PageLayout breadcrumbs={{ current: { label: "Admin Dashboard" } }}>
      <Container>
        <DashboardCard
          title="Users"
          description="Manage user accounts, subscriptions and analyze logs"
          icon={<PeopleOutlineIcon fontSize="large" />}
          navigateOptions={{ path: adminDashboardBreadcrumbs.users.link }}
        />

        <DashboardCard
          title="Subscription Plans"
          description="Access detailed information about all subscription plans"
          icon={<ChecklistIcon fontSize="large" />}
          navigateOptions={{
            path: adminDashboardBreadcrumbs.subscriptionPlans.link,
          }}
        />

        <DashboardCard
          title="Subscription Offers"
          description="Access detailed information about all subscription offers"
          icon={<PriceChangeOutlinedIcon fontSize="large" />}
          navigateOptions={{
            path: adminDashboardBreadcrumbs.subscriptionOffers.link,
          }}
        />

        <DashboardCard
          title="Event Subscriptions"
          description="Audit webhook subscriptions and delivery history across all users"
          icon={<WebhookOutlinedIcon fontSize="large" />}
          navigateOptions={{
            path: adminDashboardBreadcrumbs.eventSubscriptions.link,
          }}
        />
      </Container>
    </PageLayout>
  );
}
